import { SelectOption } from "./input";
import { InvoiceStat, OptionType } from "./types";
import { createTheme, responsiveFontSizes } from "@mui/material/styles";

export const apiBaseUrl = process.env.REACT_APP_BASE_URL;
export const SSO_BASE_URL = process.env.REACT_APP_SSO_BASE_URL;
export const redirect_url_for_download = process.env.REACT_APP_SAP_HOST_URL + process.env.REACT_APP_SAP_BASE_URL;
export const helpDeskNumber = process.env.REACT_APP_HELP_NO;

export const throughGEMOptions: SelectOption[] = [
  // { value: "yes", label: "Yes" },
  // { value: "no", label: "No" },
  { value: "gem", label: "GEM" },
  { value: "tender_wizard", label: "Tender Wizard" },
  { value: "nic", label: "NIC" },
  { value: "no", label: "NA" },
];

export const billTypeOptions: SelectOption[] = [
  { value: "first_bill", label: "First Invoice" },
  { value: "regular_bill", label: "Regular Invoice" },
  { value: "final_bill", label: "Final Invoice" },
];

export const billCategoryOptions: SelectOption[] = [
  { value: "bill", label: "Invoice" },
  { value: "credit_note", label: "Credit Note" },
  { value: "debit_note", label: "Debit Note" },
];
export const billCategoryInvoiceOptions: SelectOption[] = [
  { value: "bill", label: "Invoice" },
  // { value: "credit_note", label: "Credit Note" },
  // { value: "debit_note", label: "Debit Note" },
];

export const paymentsTrandsOption: SelectOption[] = [
  { value: "payment1", label: "payment1" },
  { value: "payment2", label: "payment2" },
  { value: "payment3", label: "payment3" },
  { value: "payment4", label: "payment4" },
  { value: "payment5", label: "payment5" },
  // { value: "credit_note", label: "Credit Note" },
  // { value: "debit_note", label: "Debit Note" },
];

export const procurementTypeOptions: SelectOption[] = [
  { value: "M", label: "Goods" },
  { value: "D", label: "Service/Works" },
  { value: "H", label: "H&T Contract" },
  { value: "O", label: "Others Contract" },
];

export const AssignedTypeOptions: SelectOption[] = [
  { value: "SATYAR", label: "SATYAR" },
  { value: "PRADEEPB", label: "PRADEEPB" },
  { value: "SIKHAS", label: "SIKHAS" },
];

export const poContractOptions: SelectOption[] = [
  { value: "po123", label: "PO123" },
  { value: "con456", label: "CON456" },
];

export const vendorData = [
  {
    vendorCode: "VND001",
    vendorName: "Alpha Supplies Ltd.",
    address: "12 MG Road, Bangalore, Karnataka",
    pinCode: "560001",
    gstin: "29ABCDE1234F1Z5",
    gstNo: "34235353543",
    bankKey: "dewe32321",
    accountNo: "12312312321",
    panNo: "231232",
  },
  {
    vendorCode: "VND001",
    vendorName: "Alpha Supplies Ltd.",
    address: "12 MG Road, Bangalore, Karnataka",
    pinCode: "560001",
    gstin: "29ABCDE1234F1Z5",
    gstNo: "34235353543",
    bankKey: "dewe32321",
    accountNo: "12312312321",
    panNo: "231232",
  },
  {
    vendorCode: "VND001",
    vendorName: "Alpha Supplies Ltd.",
    address: "12 MG Road, Bangalore, Karnataka",
    pinCode: "560001",
    gstin: "29ABCDE1234F1Z5",
    gstNo: "34235353543",
    bankKey: "dewe32321",
    accountNo: "12312312321",
    panNo: "231232",
  },
  {
    vendorCode: "VND001",
    vendorName: "Alpha Supplies Ltd.",
    address: "12 MG Road, Bangalore, Karnataka",
    pinCode: "560001",
    gstin: "29ABCDE1234F1Z5",
    gstNo: "34235353543",
    bankKey: "dewe32321",
    accountNo: "12312312321",
    panNo: "231232",
  },
  {
    vendorCode: "VND001",
    vendorName: "Alpha Supplies Ltd.",
    address: "12 MG Road, Bangalore, Karnataka",
    pinCode: "560001",
    gstin: "29ABCDE1234F1Z5",
    gstNo: "34235353543",
    bankKey: "dewe32321",
    accountNo: "12312312321",
    panNo: "231232",
  },
];

export const invoiceStatsData: InvoiceStat[] = [
  {
    id: "totalActive",
    value: 8261,
    label: "Total Active Invoices",
    actionText: "View",
    color: "primary",
  },
  {
    id: "msme",
    value: 2494,
    label: "MSME Invoices",
    actionText: "View",
    color: "neutral",
  },
  {
    id: "nonMsme",
    value: 3409,
    label: "Non-MSME Invoices",
    actionText: "View",
    color: "danger",
  },
  {
    id: "woman", // Assuming "WOMAN" refers to invoices related to women entrepreneurs/businesses
    value: 2494,
    label: "WOMAN Invoices", // Consider a more descriptive label if appropriate, e.g., "Women-Owned Business Invoices"
    actionText: "View",
    color: "success",
  },
];

export const invoiceStatData: InvoiceStat[] = [
  {
    id: "passed",
    value: 8261,
    label: "Passed Invoices",
    actionText: "View",
    color: "primary",
  },
  {
    id: "msme",
    value: 2494,
    label: "MSME Invoices",
    actionText: "View",
    color: "neutral",
  },
  {
    id: "nonMsme",
    value: 3409,
    label: "Non-MSME Invoices",
    actionText: "View",
    color: "danger",
  },
];

let muiTheme = createTheme({
  palette: {
    grey: {
      50: "#fafafa",
      100: "#f5f5f5",
      200: "#eeeeee",
      300: "#e0e0e0",
    },
    text: {
      secondary: "rgba(0, 0, 0, 0.6)",
    },
  },
  shadows: ["none", "0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)"] as any,
});

export const invoiceStatusOptionsVendor: OptionType[] = [
  { value: "Approved", label: "Approved" },
  { value: "Invoice Submitted", label: "Invoice submitted" },
  { value: "Invoice Posted", label: "Invoice Posted" },
  { value: "Paid", label: "Paid" },
  { value: "Rejected", label: "Rejected" },
];

export const invoiceStatusOptionsEmployee: OptionType[] = [
  // { value: "Approved", label: "Approved" },
  { value: "Invoice Submitted", label: "Invoice submitted" },
  { value: "Invoice Parked", label: "Invoice Parked" },
  { value: "Invoice Posted", label: "Invoice Posted" },
  { value: "Paid", label: "Paid" },
  { value: "Rejected", label: "Rejected" },
];

// Dummy data for dataApproverList.invoice_details_table
// (Matches the InvoiceDetailLineItem interface we defined)
export const dummyInvoiceLineItems = [
  {
    grn_no: "GRN001",
    po_no: "PO2024001",
    line_item: "00010",
    description: "Supply of A4 Printer Paper (500 Sheets/Ream)",
    bill_qty: "10", // Assuming quantity can be a string, adjust if it's number
    rate: "350.00",
    tax_percentage: "18.00", // Example GST
    batch_ses_no: "BATCH001A",
    hsn_sac: "480256", // HSN for paper
    tax_amount: "630.00", // 10 * 350 * 0.18 (assuming rate is pre-tax)
    amount: "3500.00", // 10 * 350 (pre-tax amount)
    bill_no: "INV-A-001",
    tax_code: "GST18",
    doc_year: "2024",
    Lfbnr: "SAPDOC001", // SAP Document Number (example)
    Spos: "00010", // SAP Item Position (example)
  },
  {
    grn_no: "GRN002",
    po_no: "PO2024001",
    line_item: "00020",
    description: "Heavy Duty Staplers - Pack of 5",
    bill_qty: "2",
    rate: "1200.00",
    tax_percentage: "12.00",
    batch_ses_no: "BATCH002B",
    hsn_sac: "847290",
    tax_amount: "288.00",
    amount: "2400.00",
    bill_no: "INV-A-001", // Same bill, different item
    tax_code: "GST12",
    doc_year: "2024",
    Lfbnr: "SAPDOC002",
    Spos: "00020",
  },
  {
    grn_no: "GRN003",
    po_no: "PO2024002",
    line_item: "00010",
    description: "Consultancy Services - Project Alpha (Man-hours)",
    bill_qty: "40", // e.g., 40 hours
    rate: "1500.00", // per hour
    tax_percentage: "18.00",
    batch_ses_no: "SES001", // Service Entry Sheet number
    hsn_sac: "998314", // SAC for IT consultancy
    tax_amount: "10800.00",
    amount: "60000.00",
    bill_no: "INV-S-005",
    tax_code: "GST18S",
    doc_year: "2024",
    Lfbnr: "SAPDOC003",
    Spos: "00010",
  },
  {
    grn_no: "GRN004",
    po_no: "PO2024003",
    line_item: "00010",
    description: "Laptop Model XYZ - Intel i7, 16GB RAM",
    bill_qty: "1",
    rate: "75000.00",
    tax_percentage: "18.00",
    batch_ses_no: "PROD001X",
    hsn_sac: "847130",
    tax_amount: "13500.00",
    amount: "75000.00",
    bill_no: "INV-P-101",
    tax_code: "GST18E",
    doc_year: "2024",
    Lfbnr: "SAPDOC004",
    Spos: "00010",
  },
  {
    grn_no: "GRN005", // Example with some missing optional data
    po_no: "PO2024004",
    line_item: "00010",
    description: "Office Refreshments - Monthly",
    bill_qty: "1", // Lump sum
    rate: "5000.00",
    tax_percentage: "5.00",
    batch_ses_no: undefined, // Or null
    hsn_sac: "996335",
    tax_amount: "250.00",
    amount: "5000.00",
    bill_no: "INV-M-077",
    tax_code: "GST5",
    doc_year: "2024",
    Lfbnr: "SAPDOC005",
    Spos: "00010",
  },
];

export const muiThemeFinal = responsiveFontSizes(muiTheme);

// export const uniqueList = [
//   {
//     username: "VOITH HYDRO PRIVATE",
//     vendor_code: "0010900003",
//   },
//   {
//     username: "A.V AIR CONDITIONING & ENGINEERING",
//     vendor_code: "0010900002",
//   },
//   {
//     username: "admin",
//     vendor_code: "0010600003",
//   },
//   {
//     username: "10500054",
//     vendor_code: "0010500054",
//   },
//   {
//     username: "Kumar Suppliers",
//     vendor_code: "0010500017",
//   },
//   {
//     username: "XYZ COMPANY",
//     vendor_code: "10500002",
//   },
//   {
//     username: "Krishna Associates ",
//     vendor_code: "0010500000",
//   },
//   {
//     username: "Krishna Associates ",
//     vendor_code: "0010400007",
//   },
//   {
//     username: "amit associates",
//     vendor_code: "0010400005",
//   },
//   {
//     username: "Ram associates ",
//     vendor_code: "0010400004",
//   },
//   {
//     username: "sachin Associates ",
//     vendor_code: "0010400003",
//   },
//   {
//     username: "Yash Associates",
//     vendor_code: "0010400002",
//   },
//   {
//     username: "Pankaj Sharma",
//     vendor_code: "0010100033",
//   },
//   {
//     username: "Ranjan Kumar",
//     vendor_code: "0010100027",
//   },
//   {
//     username: "1st name last name",
//     vendor_code: "0010100019",
//   },
//   {
//     username: "1st name last name",
//     vendor_code: "0010100015",
//   },
//   {
//     username: "NAYAN JYOTI TALUKDAR",
//     vendor_code: "0010100013",
//   },
//   {
//     username: "admin",
//     vendor_code: "10000236",
//   },
//   {
//     username: "admin",
//     vendor_code: "10000235",
//   },
//   {
//     username: "admin",
//     vendor_code: "10000234",
//   },
// ];
